import React, { Component } from 'react'
import "./home.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiBanner , getApiHome , getApiHomeMap , getRenConfig , getApiHomeService , getZbannerList , checkCompany , setCompany , getApiHomeMsList , getApiZsType , getApiHomeZsList , getApiFindWithPager , getApiServiceType , getApiSwitchActivity , getApigetCarrier , getApiswitchCusList , getApiHomeCourse , getApiCoursetype } from "../../axios/api"
import { Carousel, message } from 'antd';
import 'antd/dist/antd.css';
import CountUp from 'react-countup';
import { UrlSearch , get } from '../../axios/localstorage'

export default class home extends Component {


    state = {
        banner:[
            {
                image:"/www/assets/imgs/banner.png"
            },
            {
                image:"/www/assets/imgs/banner.png"
            },
            {
                image:"/www/assets/imgs/banner.png"
            }
        ],
        banner2:[],

        banner3:{},

        alert:false,
        loginType:false,
        showCompany:false,

        homeData:{},

        type:0,
        news:[],
        mlist:[],
        arr:[
            {},
            {},
            {},
            {},
            {},
            {}
        ],
        results:[],
        experts:[],
        arr2:[],
        arr3:[],
        arr4:[],
        arr5:[],
        currentIndex:0,
        currentIndex2:0,
        nIndex:0,

        newsType:1,

        leftList:[],
        rightList:[],

        map:[],

        data:{
            array:[],
        },

        dataChild:{},

        courseTypeArr:[],
        company:"",
        courseType:"",
        serviceType:0,
        zsType:"",
        zsList:[],
        serviceTypeList:[],
        zsTypeList:[],
        courseData:{
            first:[],
            list:[],
        }
    }

    componentWillMount(){
        window.scroll(0,0);

        
    }

    hideLoginType=()=>{
        this.setState({
            loginType:false
        })
    }

    componentDidMount(){

        let end = UrlSearch('end');

        if(end){
            window.scroll(0,5000);
        }

        getApiHome()
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    homeData:req.data.data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiHomeMap({token:get('token')})
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    map:req.data.data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiBanner()
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    banner:req.data.data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
        getRenConfig({token:get('token')})
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    banner3:req.data.data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
        getZbannerList()
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    banner2:req.data.data
                })
            }
        }).catch( err =>{
            console.error(err);
        })

        getApiCoursetype()
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    courseTypeArr:data,
                    courseType:data[0].id
                })

                this.getCourse();
            }
        }).catch( err =>{
            console.error(err);
        })
        // getApiServiceType()
        // .then( req =>{
        //     if(req.data.code === 1){

        //         let data = req.data.data;

        //         this.setState({
        //             serviceTypeList:data,
        //             serviceType:data[0].id

        //         })

        //         this.getService();
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        getApiZsType()
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    zsTypeList:data.list,
                    zsType:data.list[0].id

                })

                this.getZsList();
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiswitchCusList()
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    arr3:data,
                })
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiSwitchActivity()
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    arr4:data,
                })
            }
        }).catch( err =>{
            console.error(err);
        })

        getApigetCarrier()
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    arr5:data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiFindWithPager()
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    news:data.rows
                })
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiHomeMsList()
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    mlist:data
                })
            }
        }).catch( err =>{
            console.error(err);
        })

        getApiHomeService()
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    arr2:data,
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    getCourse=()=>{
        setTimeout(()=>{
            getApiHomeCourse({type_id:this.state.courseType})
            .then( req =>{
                if(req.data.code === 1){
                    this.setState({
                        courseData:req.data.data
                    })
                }   
            }).catch( err =>{
                console.error(err);
            })
        },50)
    }
    getZsList=()=>{
        setTimeout(()=>{
            getApiHomeZsList({type_id:this.state.zsType})
            .then( req =>{
                if(req.data.code === 1){
                    let data = req.data.data;
                    this.setState({
                        experts:data.experts,
                        results:data.results,
                    })
                }   
            }).catch( err =>{
                console.error(err);
            })
        },50)
    }

    checkCompany=(name)=>{

        let param = {
            token:get('token')
        }

        checkCompany(param)
        .then( req =>{
            if(req.data.code === 1){
                this.gotoPage(name)
            }else{
                this.setState({
                    showCompany:true
                })
            }
        }).catch( err =>{
            console.error(err);
        })

    }
    setCompany=()=>{

        let param = {
            token:get('token'),
            company:this.state.company
        }

        setCompany(param)
        .then( req =>{
            if(req.data.code === 1){
                message.success("绑定成功");
                this.setState({
                    showCompany:false
                })
            }else{
                message.info(req.data.msg);
                this.setState({
                    showCompany:false
                })
            }
        }).catch( err =>{
            console.error(err);
        })

    }

    getService=()=>{

        setTimeout(()=>{
            let param = {
                // type_id:this.state.serviceType
            }
    
            getApiHomeService()
            .then( req =>{
                if(req.data.code === 1){
    
                    let data = req.data.data;
    
                    this.setState({
                        arr2:data,
                    })
                }
            }).catch( err =>{
                console.error(err);
            })
        },50)
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }
    onChange2=(index)=>{
        this.setState({
            currentIndex2:index
        })
    }

    gotoSlide=(num)=>{
        this.refs['bslide2'].goTo(num);
    }



    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    changeShow=(index)=>{
        let arr = this.state.arr;
        if(arr[index].show){
            arr[index].show = false;
        }else{
            arr[index].show = true;
        }

        this.setState({
            arr
        })
    }

    gotoInfoPage=(page)=>{
 
        let str = window.location.href;
        var num=str.indexOf("#/") 
        str=str.substr(0,num+1); //取得所有参数   stringvar.substr(start [, length ]

        window.open(str + page);
    }


    render() {
        return (
            <div className='home'>
                <Header type={1} loginType={this.state.loginType} hideLoginType={this.hideLoginType} />
                <div className='banner'>
                    <Carousel ref="bslide" dots={false} draggable={true} afterChange={(index)=>{this.onChange(index)}} autoplay={true} autoplaySpeed={2500}>
                        {
                            this.state.banner.map((item,index)=>{
                                return <div className='item' key={index} onClick={()=>{
                                        if(item.type === 1){
                                            window.open(item.url)
                                        }
                                    }}>
                                                <div className="bg"  style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                            </div>
                                        
                            })
                        }
                    </Carousel>
                </div>

                <div className='page1' style={{backgroundImage:"url('/www/assets/imgs/beijing1.png')"}}>
                    <div className='cen'>
                        <div className='pmain'>
                            <div className='pnum'>
                                <div className='pni'>
                                    <h2><CountUp start={0} duration={2} end={this.state.homeData.policy_num} />+</h2>
                                    <p>政策</p>
                                </div>
                                <div className='pni'>
                                    <h2><CountUp start={0} duration={2} end={this.state.homeData.inchain_num} /></h2>
                                    <p>产业链</p>
                                </div>
                                <div className='pni'>
                                    <h2><CountUp start={0} duration={2} end={this.state.homeData.server_num} /></h2>
                                    <p>服务机构</p>
                                </div>
                                <div className='pni'>
                                    <h2><CountUp start={0} duration={2} end={this.state.homeData.talent_num} />+</h2>
                                    <p>人才</p>
                                </div>
                                <div className='pni'>
                                    <h2><CountUp start={0} duration={2} end={this.state.homeData.results_num} />+</h2>
                                    <p>成果</p>
                                </div>
                                <div className='pni'>
                                    <h2><CountUp start={0} duration={2} end={this.state.homeData.patent_num} /></h2>
                                    <p>专利</p>
                                </div>
                                <div className='pni'>
                                    <h2><CountUp start={0} duration={2} end={this.state.homeData.activity_nums} /></h2>
                                    <p>活动</p>
                                </div>
                                <div className='pni'>
                                    <h2><CountUp start={0} duration={2} end={this.state.homeData.park_num} /></h2>
                                    <p>园区</p>
                                </div>
                            </div>

                            <div className='pname'>
                                <img alt="" className='pimg' src="/www/assets/imgs/biaoti.png" />
                                <h1>产业图谱</h1>
                                {/* <div className='more' onClick={()=>{this.gotoPage('/industrialMap')}}>
                                    <p>查看更多</p>
                                    <img alt="" src="/www/assets/imgs/chakangengduo.png" />
                                </div> */}
                            </div>

                            <div className='pdiv'>
                                <div className='pleft'>
                                    <img alt="" src="/www/assets/imgs/chanye.png" />
                                    <h2>玄武区产业地图</h2>
                                    <div onClick={()=>{
                                        message.info('开发中...')
                                        // this.gotoPage('/industrialChain')
                                        }}>
                                        <p>立即查看</p>
                                        <img alt="" src="/www/assets/imgs/lijichakan.png" />
                                    </div>
                                </div>
                                <div className='pright'>
                                    {
                                        this.state.map.map((item,index)=>{
                                            return <div className='pri' key={index} onClick={()=>{
                                                if(!get('token')){
                                                    // message.info("请先登录")
                                                    this.setState({
                                                        loginType:true
                                                    })
                                                    return false;
                                                  }
                                                  if(!item.is_true){
                                                    message.info('暂未开通');
                                                    return false;
                                                }
                                                window.open(item.url);
                                            }}>
                                                        <div className='picon'>
                                                            <img alt="" src={item.image} />
                                                        </div>
                                                        <div className='ptext'>
                                                            <h2>{item.title}</h2>
                                                            <p>{item.tags}</p>
                                                        </div>
                                                    </div>
                                        })
                                    }

                                    <div className='pri' onClick={()=>{
                                                this.gotoPage('/industrialMap')
                                            }}>
                                        <div className='picon'>
                                            <img alt="" src="/www/assets/imgs/rrr.png" />
                                        </div>
                                        <div className='ptext'>
                                            <h2>查看更多</h2>
                                            <p>点击查看更多产业图谱</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='banner3'>
                                <Carousel ref="bslide" dots={false} draggable={true} afterChange={(index)=>{this.onChange(index)}} autoplay={true} autoplaySpeed={2500}>
                                <div className='item' onClick={()=>{
                                    if(!get('token')){
                                        // message.info("请先登录")
                                        this.setState({
                                            loginType:true
                                        })
                                        return false;
                                      }
                                      if(!this.state.banner3.is_talent){
                                        message.info('暂未开通');
                                        return false;
                                    }
                                                    window.open(this.state.banner3.url)
                                                }}>
                                    <div className="bg"  style={{backgroundImage:"url('"+this.state.banner3.image+"')"}}></div>
                                </div>
                                </Carousel>
                            </div>

                            <div className='pname'>
                                <img alt="" className='pimg' src="/www/assets/imgs/biaoti.png" />
                                <h1>服务大厅</h1>
                            </div>

                            <div className='ptype'>
                                <div className='pflex'>
                                    {/* <div onClick={()=>{this.setState({serviceType:""});this.getService()}} className={this.state.serviceType === ''?'pfi pf_active':"pfi"} style={this.state.serviceType === ''?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>全部</p>
                                    </div> */}
                                    {/* {
                                        this.state.serviceTypeList.map((item,index)=>{
                                            return <div key={index} onClick={()=>{this.setState({serviceType:item.id});this.getService()}} className={this.state.serviceType === item.id?'pfi pf_active':"pfi"} style={this.state.serviceType === item.id?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                        <p>{item.title}</p>
                                                    </div>
                                        })
                                    } */}

                                    <div onClick={()=>{this.setState({serviceType:0})}} className={this.state.serviceType === 0?'pfi pf_active':"pfi"} style={this.state.serviceType === 0?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>科技服务</p>
                                    </div>
                                    <div onClick={()=>{this.setState({serviceType:1})}} className={this.state.serviceType === 1?'pfi pf_active':"pfi"} style={this.state.serviceType === 1?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>投资机构</p>
                                    </div>
                                </div>
                                <div className='more' onClick={()=>{this.gotoPage('/service')}}>
                                    <p>查看更多</p>
                                    <img alt="" src="/www/assets/imgs/chakangengduo.png" />
                                </div>
                            </div>

                            <div >
                                <div className='pcard' hidden={this.state.serviceType === 1}>
                                    {
                                        this.state.arr2.map((item,index)=>{
                                            return <div key={index}>
                                                        
                                                        <div className='card'>
                                                            <div className='cbox'>
                                                                <div className='cimg' style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                                                <div className='ctext'>
                                                                    <h2>{item.title}</h2>
                                                                    <p>服务类型：{item.industrial}</p>
                                                                </div>
                                                            </div>
                                                            <div className='cbom'>
                                                                <img className='cimg' alt="" src="/www/assets/imgs/shangjia.png" />
                                                                <h2>科服易站服务商</h2>
                                                            </div>
                                                            <div className='mark'>
                                                                <div className='mleft'>
                                                                    <img alt="" className='mimg' src={item.qrcode} />
                                                                    <h2>扫一扫关注服务站</h2>
                                                                </div>
                                                                <div className='minfo'>
                                                                    <h2>{item.title}</h2>
                                                                    <p>科服易站服务商</p>
                                                                    <div>{item.info}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                        })
                                    }
                                </div>

                                <div className='pcard' hidden={this.state.serviceType === 0}>
                                    {
                                        this.state.mlist.map((item,index)=>{
                                            return <div className='card' key={index}>
                                                        <div className='cbox'>
                                                            <div className='cimg' style={{backgroundImage:"url('"+item.logo_text+"')"}}></div>
                                                            <div className='ctext'>
                                                                <h2>{item.nickname}</h2>
                                                                <p>机构性质：{item.nature}</p>
                                                                <p>成立时间：{item.esta_time}</p>
                                                            </div>
                                                        </div>
                                                        <div className='cbom'>
                                                            <img className='cimg' alt="" src="/www/assets/imgs/dingwei.png" />
                                                            <h2>{item.mechanism}</h2>
                                                            <div onClick={()=>{this.gotoInfoPage('/serviceinfo?id='+item.id)}}>
                                                                <p>查看详情</p>
                                                                <img alt="" src="/www/assets/imgs/chakanxiangqing.png" />
                                                            </div>
                                                        </div>
                                                    </div>
                                        })
                                    }
                                </div>
                                
                            </div>

                        </div>
                    </div>
                </div>

                <div className='page2'>
                    <div className='cen'>
                        <div className='pmain'>
                            <div className='pname'>
                                <img alt="" className='pimg' src="/www/assets/imgs/biaoti.png" />
                                <h1>技术专家/成果</h1>
                                
                            </div>
                            <div className='ptype'>
                                <div className='pflex'>
                                    {/* <div onClick={()=>{this.setState({zsType:""});this.getZsList()}} className={this.state.zsType === ''?'pfi pf_active':"pfi"} style={this.state.zsType === ''?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>全部</p>
                                    </div> */}
                                    {
                                        this.state.zsTypeList.map((item,index)=>{
                                            return <div key={index} hidden={index > 4} onClick={()=>{this.setState({zsType:item.id});this.getZsList()}} className={this.state.zsType === item.id?'pfi pf_active':"pfi"} style={this.state.zsType === item.id?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                        <p>{item.title}</p>
                                                    </div>
                                        })
                                    }
                                </div>
                            </div>

                            <div className='pbox'>
                                <div className='left'>
                                    <div className='ltop'>
                                        <div className='ltype'>
                                            <div className='lti'>
                                            技术专家
                                            <div className='lspan'></div>
                                            </div>
                                        </div>
                                        <div className='more' onClick={()=>{this.gotoPage('/talents')}}>
                                            <p>查看更多</p>
                                            <img alt="" src="/www/assets/imgs/chakangengduo.png" />
                                        </div>
                                    </div>
                                    <div className='ldiv'>
                                        <div className='none' hidden={this.state.experts.length !== 0}>
                                            <div className='cen'>
                                                <img alt="" src="/www/assets/imgs/zanwuxuexineirong.png" />
                                            </div>
                                            <p>暂无相关技术专家</p>
                                        </div>
                                        {
                                            this.state.experts.map((item,index)=>{
                                                return <div className='card' key={index} onClick={()=>{this.gotoInfoPage('/talentsinfo?id='+item.id)}}>
                                                            <div className='cimg' style={{backgroundImage:"url('"+item.avatar+"')"}}></div>
                                                            <div className='ctext'>
                                                                <h2>{item.name} <span>{item.service}/{item.posname}</span></h2>
                                                                <div className='cbox'>
                                                                    {
                                                                        item.redirection.map((elem,num)=>{
                                                                            return <div key={num}>{elem}</div>
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                            })
                                        }
                                        
                                    </div>
                                </div>
                                <div className='right'>
                                    <div className='top'>
                                        <div className='ltype'>
                                            <div className='lti'>
                                            科技成果
                                            <div className='lspan'></div>
                                            </div>
                                        </div>
                                        <div className='more' onClick={()=>{
                                            // if(!get('token')){
                                            //     message.info("请先登录")
                                            //     return false;
                                            //   }
                                            this.gotoPage('/skill')}}>
                                            <p>查看更多</p>
                                            <img alt="" src="/www/assets/imgs/chakangengduo.png" />
                                        </div>
                                    </div>
                                    <div className='box'>
                                        <div className='none' hidden={this.state.results.length !== 0}>
                                            <div className='cen'>
                                                <img alt="" src="/www/assets/imgs/zanwuxuexineirong.png" />
                                            </div>
                                            <p>暂无相关科技成果</p>
                                        </div>
                                        {
                                            this.state.results.map((item,index)=>{
                                                return <div className='item' onClick={()=>{this.gotoInfoPage('/skillinfo?id='+item.id )}} key={index}>
                                                            <h2>{item.title}</h2>
                                                            
                                                            <div className='cbox'>
                                                            <div>{item.industry_text}</div>
                                                                {/* <h4>项目负责人：<span>{item.head}</span></h4>
                                                                <h4>工作单位：<span>{item.company}</span></h4> */}
                                                            </div>
                                                            <p>{item.info}</p>
                                                        </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page3' style={{backgroundImage:"url('/www/assets/imgs/beijing2.png')"}}>
                    <div className='cen'>
                        <div className='pmain'>

                            <div className='pname'>
                                <img alt="" className='pimg' src="/www/assets/imgs/biaoti.png" />
                                <h1>科创政策</h1>
                                <div className='more' onClick={()=>{
                                    if(!get('token')){
                                        // message.info("请先登录")
                                        this.setState({
                                            loginType:true
                                        })
                                        return false;
                                      }
                                    this.gotoPage('/policy')}}>
                                    <p>查看更多</p>
                                    <img alt="" src="/www/assets/imgs/chakangengduo.png" />
                                </div>
                            </div>

                            <div className='pbox'>
                                <div className='left'>
                                    <div className='top'>
                                        <div className='ltype'>
                                            <div className='lti'>
                                            最新政策
                                            <div className='lspan'></div>
                                            </div>
                                        </div>
                                        <div className='more' onClick={()=>{
                                            if(!get('token')){
                                                this.setState({
                                                    loginType:true
                                                })
                                                return false;
                                              }
                                            this.gotoPage('/policy')}}>
                                            <p>查看更多</p>
                                            <img alt="" src="/www/assets/imgs/chakangengduo.png" />
                                        </div>
                                    </div>

                                    <div className='box'>
                                        {
                                            this.state.news.map((item,index)=>{
                                                return <div className='card' key={index} onClick={()=>{this.gotoInfoPage('/policyinfo?id='+item.id)}}>
                                                            <img alt="" src="/www/assets/imgs/wenzhang.png" />
                                                            <h2>{item.title}</h2>
                                                            <p>{item.updateDateTime}</p>
                                                        </div>
                                            })
                                        }
                                    </div>
                                </div>

                                <div className='right'>
                                    <div className='rbanner'>
                                        <Carousel ref="bslide2" dots={false} draggable={true} afterChange={(index)=>{this.onChange2(index)}} autoplay={true} autoplaySpeed={2500}>
                                            {
                                                this.state.banner2.map((item,index)=>{
                                                    return <div className='item' key={index} onClick={()=>{
                                                                    if(item.type === 1){
                                                                        window.open(item.url)
                                                                    }
                                                                }}>
                                                                    <div className="bg"  style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                                                </div>
                                                            
                                                })
                                            }
                                        </Carousel>
                                        <div className='slides'>
                                            {
                                                this.state.banner.map((item,index)=>{
                                                    return <div onClick={()=>{this.gotoSlide(index)}} key={index} className={this.state.currentIndex2 === index?'hover':''}></div>
                                                })
                                            }
                                        </div>
                                    </div>

                                    <div className='rbox'>
                                        <div className='rbi' onClick={()=>{
                                            if(!get('token')){
                                                this.setState({
                                                    loginType:true
                                                })
                                                return false;
                                              }
                                            this.gotoPage('/policySearch')}}>
                                            <div className='rimg'>
                                                <img alt="" src="/www/assets/imgs/zhengcechaxun.png" />
                                            </div>
                                            <div className='rtext'>
                                                <h2>政策查询</h2>
                                                <p>玄武区科创载体绩效考核</p>
                                            </div>
                                        </div>
                                        <div className='rbi' onClick={()=>{
                                            if(!get('token')){
                                                this.setState({
                                                    loginType:true
                                                })
                                                return false;
                                              }
                                            this.gotoPage('/policyMatching')}}>
                                            <div className='rimg'>
                                                <img alt="" src="/www/assets/imgs/zhengcejingzhunpipei.png" />
                                            </div>
                                            <div className='rtext'>
                                                <h2>政策精准匹配</h2>
                                                <p>政策扶持精准评估</p>
                                                <p>了解企业可享政策优惠</p>
                                            </div>
                                        </div>
                                        <div className='rbi' onClick={()=>{
                                            if(!get('token')){
                                                this.setState({
                                                    loginType:true
                                                })
                                                return false;
                                              }
                                            this.gotoPage('/notice')}}>
                                            <div className='rimg'>
                                                <img alt="" src="/www/assets/imgs/zizhugongshi.png" />
                                            </div>
                                            <div className='rtext'>
                                                <h2>资助公示</h2>
                                                <p>资助公示名单细节查询</p>
                                            </div>
                                        </div>
                                        <div className='rbi' onClick={()=>{
                                            if(!get('token')){
                                                this.setState({
                                                    loginType:true
                                                })
                                                return false;
                                              }
                                              this.gotoPage('/companyTest');
                                            }}
                                            >
                                            <div className='rimg'>
                                                <img alt="" src="/www/assets/imgs/gaoqiceping.png" />
                                            </div>
                                            <div className='rtext'>
                                                <h2>高企测评</h2>
                                                <p>智能化测评</p>
                                                <p>精准诊断企业申报符合度</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className='pname'>
                                <img alt="" className='pimg' src="/www/assets/imgs/biaoti.png" />
                                <h1>项目选址 <span onClick={()=>{this.setState({alert:true})}}>发布选址需求</span></h1>
                                <div className='more' onClick={()=>{this.gotoPage('/project')}}>
                                    <p>查看更多</p>
                                    <img alt="" src="/www/assets/imgs/chakangengduo.png" />
                                </div>
                            </div>

                            <div className='pcard'>
                                {
                                    this.state.arr3.map((item,index)=>{
                                        return <div className='card' key={index} onClick={()=>{this.gotoInfoPage('/projectinfo?id='+item.id)}}>
                                                    <div className='top'>
                                                        <h2>{item.title}</h2>
                                                        <p>意向区域：{item.intention}</p>
                                                        <p>产业类型：{item.industry_text}</p>
                                                        <div>
                                                            <img alt="" src="/www/assets/imgs/xiaochengxu.png" className='timg' />
                                                        </div>
                                                        
                                                    </div>
                                                    <div className='bom'>
                                                        <div className='bitem'>
                                                            <h2>{item.investment}万元</h2>
                                                            <p>投资总额</p>
                                                        </div>
                                                        <div className='bitem'>
                                                            <h2>{item.revenue}万元</h2>
                                                            <p>预期税收</p>
                                                        </div>
                                                        <div className='bitem'>
                                                            <h4>{item.createtime}</h4>
                                                            <p>发布时间</p>
                                                        </div>
                                                    </div>
                
                                                    <div className={item.show?'mark show':'mark'}>
                                                        <div className='mleft'>
                                                            <img alt="" className='mimg' src={item.code_img} />
                                                            <h2>扫一扫关注服务站</h2>
                                                        </div>
                                                        <div className='minfo'>
                                                            <h2>灵一招商小程序</h2>
                                                            <p>南京北大科技园科技发展有限公司</p>
                                                            <div>写字楼/园区数字化招商工具，包括招商获客、产业地图、客户管理、租控管理、便捷分享等功能。</div>
                                                        </div>
                                                    </div>
                                                </div>
                                    })
                                }
                            </div>

                        </div>
                    </div>
                </div>

                <div className='page4'>
                    <div className='cen'>
                        <div className='pmain'>
                            <div className='pname'>
                                <img alt="" className='pimg' src="/www/assets/imgs/biaoti.png" />
                                <h1>培训课程</h1>
                                <div className='more' onClick={()=>{window.open('https://course.pkusp.com/')}}>
                                    <p>查看更多</p>
                                    <img alt="" src="/www/assets/imgs/chakangengduo.png" />
                                </div>
                            </div>
                            <div className='ptype'>
                                <div className='pflex'>
                                    {
                                        this.state.courseTypeArr.map((item,index)=>{
                                            return <div onClick={()=>{this.setState({courseType:item.id});this.getCourse()}} className={this.state.courseType === item.id?'pfi pf_active':"pfi"} style={this.state.courseType === item.id?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                        <p>{item.title}</p>
                                                    </div>
                                        })
                                    }
                                </div>
                            </div>
                            <div className='pbox'>
                                {
                                    this.state.courseData.first.map((item,index)=>{
                                        return <div className='left' key={index} onClick={()=>{window.open(item.url)}}>
                                                    <div className='limg' style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                                    <div className='linfo'>
                                                        <h1>{item.title}</h1>
                                                        <div>
                                                            {/* <img alt="" src="/www/assets/imgs/beidalogo.png" /> */}
                                                            <h2>{item.name}</h2>
                                                            {/* <h4>{item.number}学员</h4> */}
                                                            <p>{item.money}元</p>
                                                        </div>
                                                    </div>
                                                </div>
                                    })
                                }
                                <div className='right'>
                                    {
                                        this.state.courseData.list.map((item,index)=>{
                                            return <div className='item' key={index} onClick={()=>{window.open(item.url)}}>
                                            <div className='rimg' style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                            <div className='info'>
                                                <h1>{item.title}</h1>
                                                <div>
                                                    {/* <img alt="" src="/www/assets/imgs/beidalogo.png" /> */}
                                                    <h2>{item.name}</h2>
                                                    {/* <h4>{item.number}学员</h4> */}
                                                    <p>{item.money}元</p>
                                                </div>
                                            </div>
                                        </div>
                                        })
                                    }
                                </div>
                            </div>

                            <div className='pname'>
                                <img alt="" className='pimg' src="/www/assets/imgs/biaoti.png" />
                                <h1>科创活动</h1>
                                <div className='more' onClick={()=>{this.gotoPage('/activity')}}>
                                    <h2>查看更多</h2>
                                    <img alt="" src="/www/assets/imgs/xiaji.png" />
                                </div>
                            </div>

                            <div className='pcard'>
                                {
                                    this.state.arr4.map((item,index)=>{
                                        return <div className='card' key={index} onClick={()=>{this.gotoInfoPage("/productinfo?id="+item.id)}}>
                                                    <div className='cimg' style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                                    <div className='cinfo'>
                                                        <p>{item.title}</p>
                                                    </div>
                                                    <div className={item.is_end === 1?"istatus":"ido istatus"}>{item.is_end === 1?"已结束":"进行中"}</div>
                                                </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page5' style={{backgroundImage:"url('/www/assets/imgs/beijing3.png')"}} hidden>
                    <div className='cen'>
                        <div className='pmain'>
                            <div className='pname'>
                                <img alt="" className='pimg' src="/www/assets/imgs/biaoti.png" />
                                <h1>硅巷载体</h1>
                            </div>

                            <div className='pbox'>
                                {
                                    this.state.arr5.map((item,index)=>{
                                        return <div className='card' key={index}>
                                        <div className='cimg' style={{backgroundImage:"url('"+item.image+"')"}}></div>
                                        <div className='cinfo'>
                                            <h2>{item.title}</h2>
                                            <div className='citem'>
                                                <img alt="" src="/www/assets/imgs/dingwei2.png" />
                                                <p>地址：{item.city}</p>
                                            </div>
                                            {/* <div className='citem'>
                                                <img alt="" src="/www/assets/imgs/yuanquleixing.png" />
                                                <p>园区类型：{item.ytype}</p>
                                            </div> */}
                                            <div className='citem'>
                                                <img alt="" src="/www/assets/imgs/chanyejiqun.png" />
                                                <p>产业集群：{item.arr}</p>
                                            </div>
                                        </div>
                                    </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className='alert' hidden={!this.state.alert}>
                    <div className='abox'>
                        <img alt="" onClick={()=>{this.setState({alert:false})}} className='aclose' src="/www/assets/imgs/chacha.png" />
                        <div className='aimg' style={{backgroundImage:"url('/www/assets/imgs/erweima.png')"}}></div>
                        <p>扫一扫关注灵一招商小程序</p>
                        <p>了解更多详细信息</p>
                    </div>
                </div>

                <div className='alert' hidden={!this.state.showCompany}>
                    <div className='ares'>
                        <h1>绑定企业</h1>
                        <img className='aclose' onClick={()=>{this.setState({showRegister:false,showMsg:false});this.clearInput()}} alt="" src="/www/assets/imgs/chacha.png" />
                        <h2>企业名称</h2>
                        <input type="text" placeholder='请输入企业名称' value={this.state.company} onChange={(ev)=>{this.setState({company:ev.target.value})}} />
                        
                        <div className='amsg'>
                            <p hidden={!this.state.showMsg}>{this.state.msg}</p>
                        </div>
                        <button className='abtn' onClick={()=>{this.setCompany()}}>确定绑定</button>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
